// начало яндекс-карт ya-maps
ymaps.ready(init);

function get_coords() {
  return gon.coordinaty_ya_event || gon.coordinaty_ya
}
// var prov=1;
function init() {

  var myMap = new ymaps.Map(
    "map",
    {
      center: get_coords(),
      zoom: 15,
      controls: [
        'fullscreenControl'
      ]
    }
  );
  // удаляет поле поиска по карте
  myMap.controls.remove('searchControl');

  var myGeoObject = new ymaps.GeoObject(
    {
      // Описание геометрии.
      geometry: {
        type: "Point",
        coordinates: gon.coordinaty_ya,
      },
      // Свойства.
      properties: {
        // Контент метки.
        iconContent: "Новый Акрополь",
        hintContent: "",
      },
    },
    {
      // Опции.
      // Иконка метки будет растягиваться под размер ее содержимого.
      preset: "islands#blueStretchyIcon",
      // Метку можно перемещать.
      // draggable: true
    }
  );
  // Создание метки со сложной фигурой активной области.
  var polygonLayout = ymaps.templateLayoutFactory.createClass(
    '<div class="placemark_layout_container"><div class="polygon_layout"></div></div>'
  );

  var polygonPlacemark = new ymaps.Placemark(
    get_coords(),
    {
      // hintContent: "Новый Акрополь",
      hintContent: "",
    },
    {
      iconLayout: polygonLayout,
      // Описываем фигуру активной области "Полигон".
      iconShape: {
        type: "Polygon",
        // Полигон описывается в виде трехмерного массива. Массив верхнего уровня содержит контуры полигона.
        // Первый элемента массива - это внешний контур, а остальные - внутренние.
        coordinates: [
          // Описание внешнего контура полигона в виде массива координат.
          [
            [-28, -76],
            [28, -76],
            [28, -20],
            [12, -20],
            [0, -4],
            [-12, -20],
            [-28, -20],
          ],
          // , ... Описание внутренних контуров - пустых областей внутри внешнего.
        ],
      },
    }
  );
  myMap.geoObjects
    .add(
      new ymaps.Placemark(
        get_coords(),
        {},
        {
          preset: "islands#circleDotIcon",
          iconColor: "#008463",
        }
      )
    )
    .add(polygonPlacemark);
}
